import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import React from "react";
import styled from "styled-components";

const Container = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid var(--grey150);
`;

const ImageContainer = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin: 1.5rem;
`;

const TextContainer = styled("div")`
  flex-grow: 1;
  gap: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
`;

function SimpleArticleCardSkeleton() {
  return (
    <Container>
      <ImageContainer>
        <FixaSkeleton height="73px" width="73px" />
      </ImageContainer>
      <TextContainer>
        <FixaSkeleton height="15px" width="255px" />
        <FixaSkeleton height="15px" width="155px" />
        <FixaSkeleton height="15px" width="215px" />
      </TextContainer>
    </Container>
  );
}

export default React.memo(SimpleArticleCardSkeleton);
